module.exports = __webpack_public_path__ + "img/plus.d884631d.svg";